var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeature5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 240.611,
    height: 133.249,
    viewBox: "0 0 240.611 133.249",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#3f3d56;}.b{fill:#707070;}.c{fill:#0f4b73;}.d{fill:#f2f2f2;}.e{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-25.196 -60.365)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M548.166,282.177H463.572v-.443a1.3,1.3,0,0,0-1.3-1.3H426.514a1.3,1.3,0,0,0-1.3,1.3v.443H340.271a5.722,5.722,0,0,0-5.722,5.722V403.735a5.722,5.722,0,0,0,5.722,5.722H548.166a5.722,5.722,0,0,0,5.722-5.722V287.9A5.722,5.722,0,0,0,548.166,282.177Z",
    transform: "translate(-298.717 -220.069)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M358.653,314.131a.536.536,0,0,0-.535.536V424.539a.536.536,0,0,0,.535.535H557.447a.536.536,0,0,0,.535-.535V314.666a.536.536,0,0,0-.535-.536Z",
    transform: "translate(-312.549 -239.844)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2.092,
    cy: 2.092,
    r: 2.092,
    transform: "translate(143.234 64.898)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M542.59,570.622H522.682v-2.056c0-.113-.127-.2-.284-.2h-6.826c-.157,0-.284.092-.284.2v2.056h-4.266v-2.056c0-.113-.127-.2-.284-.2H503.91c-.157,0-.284.092-.284.2v2.056H499.36v-2.056c0-.113-.127-.2-.284-.2H492.25c-.157,0-.284.092-.284.2v2.056H487.7v-2.056c0-.113-.127-.2-.284-.2h-6.826c-.157,0-.284.092-.284.2v2.056h-4.266v-2.056c0-.113-.127-.2-.284-.2h-6.826c-.157,0-.284.092-.284.2v2.056h-4.266v-2.056c0-.113-.127-.2-.284-.2h-6.826c-.157,0-.284.092-.284.2v2.056h-4.266v-2.056c0-.113-.127-.2-.284-.2H398.963c-.157,0-.284.092-.284.2v2.056h-4.266v-2.056c0-.113-.127-.2-.284-.2H387.3c-.157,0-.284.092-.284.2v2.056h-4.266v-2.056c0-.113-.127-.2-.284-.2h-6.826c-.157,0-.284.092-.284.2v2.056h-4.266v-2.056c0-.113-.127-.2-.284-.2h-6.826c-.157,0-.284.092-.284.2v2.056H359.43v-2.056c0-.113-.127-.2-.284-.2H352.32c-.157,0-.284.092-.284.2v2.056H347.77v-2.056c0-.113-.127-.2-.284-.2h-6.826c-.157,0-.284.092-.284.2v2.056h-4.266v-2.056c0-.113-.127-.2-.284-.2H329c-.157,0-.284.092-.284.2v2.056H315.631c-3.77,0-6.826,2.2-6.826,4.907v2.219c0,2.71,3.056,4.907,6.826,4.907H542.59c3.77,0,6.826-2.2,6.826-4.907v-2.219C549.416,572.819,546.36,570.622,542.59,570.622Z",
    transform: "translate(-283.61 -389.041)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M459.856,424.7H401.1a.463.463,0,1,1,0-.925h58.759a.463.463,0,1,1,0,.925Z",
    transform: "translate(-337.5 -304.191)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M459.856,449.34H401.1a.463.463,0,1,1,0-.925h58.759a.463.463,0,1,1,0,.925Z",
    transform: "translate(-337.5 -318.65)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M459.856,473.977H401.1a.463.463,0,1,1,0-.925h58.759a.463.463,0,1,1,0,.925Z",
    transform: "translate(-337.5 -333.108)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 75.415,
    height: 72.639,
    rx: 3.36,
    transform: "translate(148.034 93.908)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M642.653,429.752a18.594,18.594,0,0,1,36.482-3.92c.225-.008.45-.017.678-.017a7.3,7.3,0,0,1,2.278.388c9.249,3.037,6.814,16.846-2.921,16.846H655.245a12.577,12.577,0,0,1-12.6-13.022Q642.646,429.889,642.653,429.752Z",
    transform: "translate(-479.518 -297.401)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M451.929,344.26v-7.611h-4.1v7.611h-3.272l2.66,4.608,2.661,4.608,2.66-4.608,2.66-4.608Z",
    transform: "translate(-266.986 -212.198)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature5);
export default __webpack_public_path__ + "static/media/feature5.bf074b1b4ea2f12e9b59b763226d555a.svg";
export { ForwardRef as ReactComponent };